import React from 'react';
import {Space, Tag} from 'antd';
import {AntButton} from '../../../Shared/UI/Ant';
import {ROLE_TAG_COLOR} from '../Constants';
import {ColDef} from 'ag-grid-community';

export const UserColumns = (deleteUser, changeUserSetting, showAccessSettings, deleteMFAUserSetting): ColDef[] => [
	{
		headerName: 'Role',
		field: 'access_settings',
		minWidth: 150,
		valueGetter: ({data}) => data.access_settings?.settings?.roles,
		filterValueGetter: ({data}) => {
			const roles = data.access_settings?.settings?.roles || [];
			return roles.map((role: string) => role.toUpperCase());
		},
		cellRenderer: ({value}) => {
			const roles = value || [];
			return roles.map(tag => (
				<Tag color={ROLE_TAG_COLOR[tag.toUpperCase() as keyof typeof ROLE_TAG_COLOR]} key={tag}>
					{tag.toUpperCase()}
				</Tag>
			));
		},
	},
	{
		headerName: 'Active',
		field: 'access_settings',
		maxWidth: 150,
		valueGetter: ({data}) => data.access_settings?.settings?.active,
		filterValueGetter: ({data}) => (data.access_settings?.settings?.active ? 'Active' : 'Inactive'),
		cellRenderer: ({value}) => (
			<div style={{display: 'grid', placeItems: 'center', height: '100%'}}>
				<div
					style={{
						margin: '0 auto',
						borderRadius: '50%',
						width: 8,
						height: 8,
						backgroundColor: value ? '#52c41a' : '#f5222d',
					}}
				/>
			</div>
		),
		cellStyle: {textAlign: 'center'},
	},
	{
		headerName: 'Access',
		field: 'access_settings',
		maxWidth: 150,
		valueGetter: ({data}) => data.access_settings?.settings?.access,
		filterValueGetter: ({data}) => (data.access_settings?.settings?.access ? 'Granted' : 'Denied'),
		cellRenderer: ({value}) => (
			<div style={{display: 'grid', placeItems: 'center', height: '100%'}}>
				<div
					style={{
						margin: '0 auto',
						borderRadius: '50%',
						width: 8,
						height: 8,
						backgroundColor: value ? '#52c41a' : '#f5222d',
					}}
				/>
			</div>
		),
		cellStyle: {textAlign: 'center'},
		comparator: (a, b) => a.localeCompare(b, undefined, {sensitivity: 'accent'}),
	},
	{
		headerName: 'First name',
		field: 'first_name',
		filter: 'agTextColumnFilter',
		sortable: true,
		comparator: (a, b) => a.localeCompare(b, undefined, {sensitivity: 'accent'}),
	},
	{
		headerName: 'Last name',
		field: 'last_name',
		filter: 'agTextColumnFilter',
		sortable: true,
		comparator: (a, b) => a.localeCompare(b, undefined, {sensitivity: 'accent'}),
	},
	{
		headerName: 'Email/Login',
		field: 'email',
		filter: 'agTextColumnFilter',
		sortable: true,
		comparator: (a, b) => a.localeCompare(b, undefined, {sensitivity: 'accent'}),
	},
	{
		headerName: 'Access Settings',
		field: 'access_settings',
		minWidth: 180,
		filter: false,
		sortable: false,
		hide: true,
		cellRenderer: ({data}) => (
			<Space size="small">
				<AntButton onClick={() => showAccessSettings(data)}>Show Access Settings</AntButton>
			</Space>
		),
	},
	{
		headerName: 'Action',
		field: 'action',
		minWidth: 400,
		filter: false,
		sortable: false,
		cellRenderer: ({data: record}) => {
			const settings = record.access_settings?.settings;
			if (!settings) return null;
			const active = !settings.active;
			const access = settings.access;
			const mfaOn = record.access_settings.mfaEnabled || record.access_settings.mfaSecret;
			return (
				<Space>
					{mfaOn && (
						<AntButton onClick={() => deleteMFAUserSetting(record)} disabled={!mfaOn} style={{minWidth: 130}}>
							Reset 2FA
						</AntButton>
					)}
					<AntButton
						onClick={() =>
							changeUserSetting(record, {
								key: 'settings',
								setting: 'access',
								value: !access,
							})
						}
						disabled={active}
						style={{minWidth: 130}}
					>
						{access ? 'Disable Access' : 'Enable Access'}
					</AntButton>
					<AntButton id={record.first_name} danger onClick={() => deleteUser(record)}>
						Delete
					</AntButton>
				</Space>
			);
		},
	},
];
